// src/pages/TasksPage.tsx
import React, { useState } from "react";
import TaskList from "../components/TaskList";
import TaskDialog from "../components/TaskDialog"; // Import the new TaskDialog
import TaskService from "../services/task.service";
import { Task } from "../types/task";

const TasksPage: React.FC = () => {
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);
  const [tasksChanged, setTasksChanged] = useState<number>(0);
  const [showTaskDialog, setShowTaskDialog] = useState<boolean>(false); // State for dialog visibility

  const handleCreateOrUpdateTask = async (
    taskData: Omit<Task, "id" | "createdAt" | "updatedAt" | "userId">
  ) => {
    try {
      if (selectedTask) {
        // Update existing task
        await TaskService.updateTask(selectedTask.id!, taskData);
        alert("Task updated successfully!");
      } else {
        // Create new task
        await TaskService.createTask(taskData);
        alert("Task created successfully!");
      }
      setSelectedTask(null); // Clear form after submission
      setTasksChanged((prev) => prev + 1); // Trigger TaskList re-fetch
      setShowTaskDialog(false); // Hide the dialog after submission
    } catch (error: any) {
      alert(`Error: ${error.message || "Failed to save task."}`);
      console.error("Save task error:", error);
      setTasksChanged((prev) => prev + 1); // Re-fetch even on error for sync
    }
  };

  const handleEditTask = (task: Task) => {
    setSelectedTask(task);
    setShowTaskDialog(true); // Show dialog when editing
  };

  const handleCloseDialog = () => {
    setSelectedTask(null); // Clear selected task when dialog closes
    setShowTaskDialog(false); // Hide the dialog
  };

  const handleAddTaskClick = () => {
    setSelectedTask(null); // Ensure no task is selected when adding new
    setShowTaskDialog(true); // Show dialog for adding
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12"> {/* TaskList takes full width */}
          {/* Button to show the dialog for adding a new task */}
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-primary" onClick={handleAddTaskClick}>
              Add New Task
            </button>
          </div>

          <TaskList
            onTaskSelectedForEdit={handleEditTask}
            selectedTask={selectedTask}
            clearSelectedTask={handleCloseDialog} // This now acts as a close mechanism if TaskList needs it
            tasksChanged={tasksChanged}
            // No need to pass showTaskForm/setShowTaskForm directly to TaskList anymore,
            // as TaskList only triggers edit/delete, not form visibility directly.
            // onTaskSelectedForEdit and handleAddTaskClick (in this component) control the dialog.
          />
        </div>
      </div>

      {/* Render the TaskDialog */}
      <TaskDialog
        isOpen={showTaskDialog}
        onClose={handleCloseDialog}
        initialTask={selectedTask}
        onSubmit={handleCreateOrUpdateTask}
      />
    </div>
  );
};

export default TasksPage;